import styled from 'styled-components';
// import palette from '../../../lib/styles/palette';
import React, { useEffect, useState } from 'react';
import DrivePulleyFormSingle from './DrivePulleyFormSingle';
import DrivePulleyFormDual from './DrivePulleyFormDual';
import DrivePulleyFormTriple from './DrivePulleyFormTriple';

const DrivePulleySelectionForm = ({ drives, pulleys, belt, }) => {
    const [, setDriveType] = useState('');

    /* drive(s) 수량 변경을 체크하여 폼 선택 */
    useEffect(() => {
        if (!drives || !Array.isArray(drives)) return;

        setDriveType(drives.length === 1 ? 'single' : drives.length === 2 ? 'dual' : 'triple');
    }, [drives]);

    return (
        <Wrapper>
            <Title>
                <h3>Drive Pulley(s)</h3>
            </Title>
            <Content>
                <Spacer />
                {drives.length === 1 && (
                    <DrivePulleyFormSingle
                        drives={drives}
                        pulleys={pulleys}
                        belt={belt}
                        // beltWidth={beltWidth}
                    />
                )}
                {drives.length === 2 && (
                    <DrivePulleyFormDual
                        drives={drives}
                        pulleys={pulleys}
                        belt={belt}
                        // beltWidth={beltWidth}
                    />
                )}
                {drives.length === 3 && (
                    <DrivePulleyFormTriple
                        drives={drives}
                        pulleys={pulleys}
                        belt={belt}
                    />
                )}
            </Content>
        </Wrapper>
    );
};

export default DrivePulleySelectionForm;

const Wrapper = styled.div``;
const Title = styled.div``;
const Content = styled.div``;

// const DrivePulleySelectionFormBlock = styled.div`
//     // background-color: yellow;
//     width: 100%;
//     max-width: 1000px;
//     // margin: 0 auto;
//     margin-top: 2rem;
//     td {
//         padding: 0.125rem 0.5rem;
//         // border: 1px solid;
//     }
// `;

// const Table = styled.div`
//     width: 100%;
//     border-collapse: collapse;
//     .tr-hover-effect {
//         &:hover {
//             background-color: ${palette.gray[1]};
//             transition: 0.3s;
//         }
//     }
// `;

const Spacer = styled.div`
    margin-bottom: 1rem;
`;
